import React from "react";
import { OutletType } from "../models/outlet_type_enum";
import Select from "react-select";

type OutletTypeOptionModel = {
    label: string;
    value: OutletType;
};

type Props = {
    selectedOption?: OutletType;
    onChange: (value: OutletType) => void;
};

export default class OutletTypeDropdownWidget extends React.Component<Props> {
    render(): React.ReactNode {
        const { selectedOption: value, onChange } = this.props;

        const options = Object.values(OutletType).map((type) => ({
            label: type.replaceAll("_", " "),
            value: type,
        }));

        const currentValue = value
            ? {
                  label: value.replaceAll("_", " "),
                  value: value,
              }
            : null;

        return (
            <>
                <label className="block text-white font-medium">
                    Tujuan Form
                </label>
                <Select<OutletTypeOptionModel>
                    options={options}
                    value={currentValue}
                    onChange={(selected) => {
                        if (selected) {
                            onChange(selected.value);
                        }
                    }}
                    isClearable
                />
            </>
        );
    }
}
